
define('text!plugins/boolean/template.html',[],function () { return '<div class="row">\n    <div class="large-12 small-centered columns checkboxMarginTop">\n        <input type="checkbox" data-rv-checked="model:value">\n    </div>\n</div>\n';});

